var map = {
	"./account.svg": "./src/icons/svg/account.svg",
	"./action.svg": "./src/icons/svg/action.svg",
	"./at.svg": "./src/icons/svg/at.svg",
	"./auto-save.svg": "./src/icons/svg/auto-save.svg",
	"./bad-active.svg": "./src/icons/svg/bad-active.svg",
	"./bad.svg": "./src/icons/svg/bad.svg",
	"./check-circle.svg": "./src/icons/svg/check-circle.svg",
	"./cm-css.svg": "./src/icons/svg/cm-css.svg",
	"./cm-folder.svg": "./src/icons/svg/cm-folder.svg",
	"./cm-html.svg": "./src/icons/svg/cm-html.svg",
	"./cm-js.svg": "./src/icons/svg/cm-js.svg",
	"./cm-md.svg": "./src/icons/svg/cm-md.svg",
	"./cm-svg.svg": "./src/icons/svg/cm-svg.svg",
	"./cm-ts.svg": "./src/icons/svg/cm-ts.svg",
	"./cm-tsx.svg": "./src/icons/svg/cm-tsx.svg",
	"./code.svg": "./src/icons/svg/code.svg",
	"./copy.svg": "./src/icons/svg/copy.svg",
	"./crown.svg": "./src/icons/svg/crown.svg",
	"./css.svg": "./src/icons/svg/css.svg",
	"./doc.svg": "./src/icons/svg/doc.svg",
	"./draft.svg": "./src/icons/svg/draft.svg",
	"./empty-invite.svg": "./src/icons/svg/empty-invite.svg",
	"./exitfullscreen.svg": "./src/icons/svg/exitfullscreen.svg",
	"./facebook.svg": "./src/icons/svg/facebook.svg",
	"./faviconLoaded.svg": "./src/icons/svg/faviconLoaded.svg",
	"./file-zip-o.svg": "./src/icons/svg/file-zip-o.svg",
	"./file.svg": "./src/icons/svg/file.svg",
	"./folder.svg": "./src/icons/svg/folder.svg",
	"./fullscreen.svg": "./src/icons/svg/fullscreen.svg",
	"./gift.svg": "./src/icons/svg/gift.svg",
	"./go.svg": "./src/icons/svg/go.svg",
	"./goback.svg": "./src/icons/svg/goback.svg",
	"./good-active.svg": "./src/icons/svg/good-active.svg",
	"./good.svg": "./src/icons/svg/good.svg",
	"./google.svg": "./src/icons/svg/google.svg",
	"./home-agent-all.svg": "./src/icons/svg/home-agent-all.svg",
	"./home-agent-custom.svg": "./src/icons/svg/home-agent-custom.svg",
	"./home-agent-super.svg": "./src/icons/svg/home-agent-super.svg",
	"./home-ai-chat.svg": "./src/icons/svg/home-ai-chat.svg",
	"./home-ai-designer.svg": "./src/icons/svg/home-ai-designer.svg",
	"./home-ai-docs.svg": "./src/icons/svg/home-ai-docs.svg",
	"./home-ai-image.svg": "./src/icons/svg/home-ai-image.svg",
	"./home-ai-meeting.svg": "./src/icons/svg/home-ai-meeting.svg",
	"./home-ai-music.svg": "./src/icons/svg/home-ai-music.svg",
	"./home-ai-sheets.svg": "./src/icons/svg/home-ai-sheets.svg",
	"./home-ai-slides.svg": "./src/icons/svg/home-ai-slides.svg",
	"./home-ai-video.svg": "./src/icons/svg/home-ai-video.svg",
	"./home-ai-web-developer.svg": "./src/icons/svg/home-ai-web-developer.svg",
	"./home-full.svg": "./src/icons/svg/home-full.svg",
	"./home-o.svg": "./src/icons/svg/home-o.svg",
	"./html.svg": "./src/icons/svg/html.svg",
	"./invite-code.svg": "./src/icons/svg/invite-code.svg",
	"./javascript.svg": "./src/icons/svg/javascript.svg",
	"./json.svg": "./src/icons/svg/json.svg",
	"./language.svg": "./src/icons/svg/language.svg",
	"./like-active.svg": "./src/icons/svg/like-active.svg",
	"./like.svg": "./src/icons/svg/like.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./linkedin.svg": "./src/icons/svg/linkedin.svg",
	"./logout.svg": "./src/icons/svg/logout.svg",
	"./mail.svg": "./src/icons/svg/mail.svg",
	"./markdown.svg": "./src/icons/svg/markdown.svg",
	"./md-file.svg": "./src/icons/svg/md-file.svg",
	"./media-canvas-edit-image.svg": "./src/icons/svg/media-canvas-edit-image.svg",
	"./media-canvas-remove-background.svg": "./src/icons/svg/media-canvas-remove-background.svg",
	"./modify-name.svg": "./src/icons/svg/modify-name.svg",
	"./newlinkopen.svg": "./src/icons/svg/newlinkopen.svg",
	"./project-list.svg": "./src/icons/svg/project-list.svg",
	"./python.svg": "./src/icons/svg/python.svg",
	"./questionnaire_full.svg": "./src/icons/svg/questionnaire_full.svg",
	"./questionnaire_whit.svg": "./src/icons/svg/questionnaire_whit.svg",
	"./reddit.svg": "./src/icons/svg/reddit.svg",
	"./refresh.svg": "./src/icons/svg/refresh.svg",
	"./regenerate.svg": "./src/icons/svg/regenerate.svg",
	"./replying.svg": "./src/icons/svg/replying.svg",
	"./requirement-check.svg": "./src/icons/svg/requirement-check.svg",
	"./save.svg": "./src/icons/svg/save.svg",
	"./send-active.svg": "./src/icons/svg/send-active.svg",
	"./send.svg": "./src/icons/svg/send.svg",
	"./settings.svg": "./src/icons/svg/settings.svg",
	"./share.svg": "./src/icons/svg/share.svg",
	"./skill-category-brand.svg": "./src/icons/svg/skill-category-brand.svg",
	"./skill-category-clothing.svg": "./src/icons/svg/skill-category-clothing.svg",
	"./skill-category-ecommerce.svg": "./src/icons/svg/skill-category-ecommerce.svg",
	"./skill-category-other.svg": "./src/icons/svg/skill-category-other.svg",
	"./skill-category-poster.svg": "./src/icons/svg/skill-category-poster.svg",
	"./skill-category-social.svg": "./src/icons/svg/skill-category-social.svg",
	"./skill-category-video-marketing.svg": "./src/icons/svg/skill-category-video-marketing.svg",
	"./skill-category-video-product.svg": "./src/icons/svg/skill-category-video-product.svg",
	"./skill-category-video-scenes.svg": "./src/icons/svg/skill-category-video-scenes.svg",
	"./skill-category-video-script.svg": "./src/icons/svg/skill-category-video-script.svg",
	"./skill.svg": "./src/icons/svg/skill.svg",
	"./star.svg": "./src/icons/svg/star.svg",
	"./still_more.svg": "./src/icons/svg/still_more.svg",
	"./still_more_full.svg": "./src/icons/svg/still_more_full.svg",
	"./tb-img.svg": "./src/icons/svg/tb-img.svg",
	"./tb-link.svg": "./src/icons/svg/tb-link.svg",
	"./tb-text.svg": "./src/icons/svg/tb-text.svg",
	"./theme.svg": "./src/icons/svg/theme.svg",
	"./tool-group.svg": "./src/icons/svg/tool-group.svg",
	"./tool-more.svg": "./src/icons/svg/tool-more.svg",
	"./tool-search.svg": "./src/icons/svg/tool-search.svg",
	"./users-outline.svg": "./src/icons/svg/users-outline.svg",
	"./vue.svg": "./src/icons/svg/vue.svg",
	"./web-dev-build.svg": "./src/icons/svg/web-dev-build.svg",
	"./web-dev-code-generate.svg": "./src/icons/svg/web-dev-code-generate.svg",
	"./web-dev-read-project.svg": "./src/icons/svg/web-dev-read-project.svg",
	"./web-dev-save-project.svg": "./src/icons/svg/web-dev-save-project.svg",
	"./web-dev-select-template.svg": "./src/icons/svg/web-dev-select-template.svg",
	"./web-search.svg": "./src/icons/svg/web-search.svg",
	"./web.svg": "./src/icons/svg/web.svg",
	"./wechat.svg": "./src/icons/svg/wechat.svg",
	"./whatsapp.svg": "./src/icons/svg/whatsapp.svg",
	"./x-twitter.svg": "./src/icons/svg/x-twitter.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";